import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import Router from "./router";
import store from "@store/index";
import Scrollbars from "react-custom-scrollbars";
import PubSub from "@common/utils/pubsub";
import { setAxios, setProxyHost } from "fe-toolkit";
import "@common/utils/dom";
import { initKeys, initOptions, initUserId } from "one-amplitude";
import http, { initCollectApiInfo } from "@common/utils/http";
import { AmplitudeProjectName } from "@common/enums";
import { iframePostMessage, isOneMaintenanceApp } from '@common/utils';
import { startRefreshGuard } from '@common/utils/refreshGuard';
import { PostMessageType } from "@common/enums";
window.store = store;
var scrollBar = null;
PubSub.subscribe("scrollto", function (top) {
    var fn = function () {
        scrollBar.scrollTop(top);
    };
    setTimeout(fn, 200);
});
setProxyHost("http://localhost:3003");
setAxios(http);
var defaultProjectName = AmplitudeProjectName.Default;
initKeys([
    {
        host: 'ihrsp-onedev.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'ihrsp-onestage.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'ihrsp-onetest.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'ihrsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'localhost:8085',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'gpsrsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'hparsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    }
], defaultProjectName);
initUserId(defaultProjectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, defaultProjectName);
var projectName = "Coca-cola";
initKeys([
    {
        host: 'ihrsp-onedev.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'ihrsp-onestage.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'ihrsp-onetest.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'ihrsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    },
    {
        host: 'localhost:8085',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    },
    {
        host: 'gpsrsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    },
    {
        host: 'hparsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    }
], projectName);
initUserId(projectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, projectName);
var arkOTPProjectName = AmplitudeProjectName.ARK_RSP_OTP;
initKeys([
    {
        host: 'arkhomesforrentrsp-onedev.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'arkhomesforrentrsp-onestage.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'arkhomesforrentrsp-onetest.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    },
    {
        host: 'arkhomesforrentrsp-one.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    },
    {
        host: 'localhost:8085',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    }
], arkOTPProjectName);
initUserId(arkOTPProjectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, arkOTPProjectName);
var newLoginProjectName = AmplitudeProjectName.NewLogin;
initKeys([
    {
        host: 'ihrsp-onedev.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'ihrsp-onestage.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'ihrsp-onetest.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'ihrsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    },
    {
        host: 'localhost:8085',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    },
    {
        host: 'gpsrsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    },
    {
        host: 'hparsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    }
], newLoginProjectName);
initUserId(newLoginProjectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, newLoginProjectName);
initCollectApiInfo(http);
iframePostMessage(PostMessageType.Init_Page_Info);
// The One Maintenance App's sign-in hand-off, moved here from the backend host page so it works on
// a static page. account/* and error/* are exempt: the hand-off sends an expired session to sign in.
var appExemptRoute = /^#\/(account|error)\//i;
if (isOneMaintenanceApp() && !appExemptRoute.test(window.location.hash)) {
    window.location.replace(window.location.pathname + "#/account/appSsoSuccess");
}
else if (window.__RSP_STATIC_HOST__) {
    // Static page only: the Razor host page runs the legacy refresh_util.js, and both would share
    // one counter.
    startRefreshGuard();
}
ReactDOM.render(React.createElement(Scrollbars, { ref: function (dom) { return (scrollBar = dom); }, autoHide: true },
    React.createElement(Provider, { store: store },
        React.createElement(Router, null))), document.body);
// 添加热模块替换(HMR)支持
if (module.hot) {
    module.hot.accept('./router', function () {
        // 重新渲染应用
        ReactDOM.render(React.createElement(Scrollbars, { ref: function (dom) { return (scrollBar = dom); }, autoHide: true },
            React.createElement(Provider, { store: store },
                React.createElement(Router, null))), document.body);
    });
}
